import _ from "lodash";

export const Getters = {
    snapshotDateFilter: state => {
      return state.snapshotDateFilter;
    },
    getToken: state => {
      return state.token;
    },
    getSearchFilterObj: state => {
      return state.searchFilterObj;
    },
    getSortBy: state => {
      return state.sortBy;
    },
    getSortDesc: state => {
      return state.sortDesc;
    },
    getAllEstimates: state => {
        let cards = _.orderBy(state.items, ['estimate_id'],['desc']);
        return cards;
    },
    getTimestamp: state => {
        return state.timestamp;
    },
    getEstimatesPerPage: (state) => {
        return state.estimatesPerPage;
    },
    getEstimatesAllCurrentPage: (state) => {
        return state.estimatesAllCurrentPage;
    },
}
